import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { PatternMode } from '../../../types/vendor-types';

interface UpdatePatternPayload {
  id: number;
  data: {
    label?: string | null;
    pattern?: string;
    pattern_mode?: PatternMode;
    case_sensitive?: boolean;
    priority?: number;
  };
}

const useUpdateVendorDetectionPattern = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: UpdatePatternPayload) => {
      return (await glynt).vendor.updateVendorDetectionPattern(id, data);
    },

    ...callbacks,

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['vendors']
      });
    }
  });
};

export default useUpdateVendorDetectionPattern;
